(function(){
  "use strict";
  
  const getMetadata = () => {
  
    const getCustomerId = () => {
      return Cookies.get('scopio_customer_id') ? Cookies.get('scopio_customer_id') : ""; // TODO: Get ID
    }
  
    const getPositionInformation = image => {
      var positionInformation = {};
      positionInformation.screenPositionX = window.pageXOffset;
      positionInformation.screenPositionY = window.pageYOffset;
      positionInformation.elementPositionX = image.offsetLeft ? image.offsetLeft : image.offsetWidth; 
      positionInformation.elementPositionY = image.offsetTop ? image.offsetTop : image.offsetHeight;
      positionInformation.screenSize = document.body.scrollHeight;
      positionInformation.scrollPositionYPercentage = Math.round( positionInformation.screenPositionY/positionInformation.screenSize*100)
      return positionInformation;
    };
  
  
    const getUrlParameter = name => {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
  
    const getSearchTerm = () => {
      if(window.location.pathname === "/search"){
        return getUrlParameter("q");
      }
      return "";
    }
  
    const getCurrentPage = () => {
      return document.location.pathname;
    };
  
    const getImageSize = image => {
  
      var imageSize = {};
      imageSize.width = image.width;
      imageSize.height = image.height;
      return imageSize;
    }
  
    const getOSName = () => {
      var OSName = "Unknown OS";
      if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
      if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
      if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
      if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
      if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";
      return OSName;
    }
  
    const getDeviceInformation = () => {
      var deviceInformation = {};
      deviceInformation.browser = navigator.appName;
      deviceInformation.version = navigator.appVersion;
      deviceInformation.userAgent = navigator.userAgent;
      deviceInformation.os = getOSName();
      return deviceInformation;
    }
  
    const getImageId = image => {
      return image.getAttribute("data-id") ? image.getAttribute("data-id") : image.parentElement.parentElement.querySelector("div.img-tools-grid").id;
    }
  
    const getUserTiming = () => {
      return new Date().toISOString();
    }
    
    const getImageMetadata = image => {
      
      var metadata = {};
      metadata.imageId=getImageId(image);
      metadata.customerId = getCustomerId();
      metadata.positionInformation = getPositionInformation(image);
      metadata.page = getCurrentPage();
      metadata.imageSize = getImageSize(image);
      metadata.searchTerm =  getSearchTerm();
      metadata.deviceInformation = getDeviceInformation();
      metadata.userDateTime = getUserTiming();
      metadata.type = "impression";
      return JSON.stringify(metadata);
    };
  
    return ({
      getImageMetadata: getImageMetadata
    });
  
  }
  
  const validateElementInGrid = element => {
    var top = element.offsetTop;
    var left = element.offsetLeft;
    var width = element.offsetWidth;
    var height = element.offsetHeight;
  
    while (element.offsetParent) {
      element = element.offsetParent;
      top += element.offsetTop;
      left += element.offsetLeft;
    }
    return (
      top >= window.pageYOffset &&
      left >= window.pageXOffset &&
      (top + height) <= (window.pageYOffset + window.innerHeight) &&
      (left + width) <= (window.pageXOffset + window.innerWidth)
    );
  }

  const pushImpression = imageMetada => {
    const host = "https://metrics.scop.io/impressions?i="
    new Image().src = host + btoa(imageMetada);
  }
  
  
  const getImageSelector = () => {
    const homePageImagesSelector = "div.jg-entry.jg-entry-visible a div:not([data-impressed='true'])";
    const searchBarImageSelector = "div.jg-entry.jg-entry-visible a div:not([data-impressed='true'])";    
    if(window.location.pathname === "/search"){
      return searchBarImageSelector;
    }
    return homePageImagesSelector;
  }
  
  const getImages = () => {
    const imageSelector = getImageSelector();
    var images = document.querySelectorAll(imageSelector);
    return images;
  }
  
  const validateImpressions = () => {
    const notImpressionImages = getImages();
    for (let image of notImpressionImages) {
      if (validateElementInGrid(image)) {
        const metadata = getMetadata().getImageMetadata(image);
        pushImpression(metadata);
        image.setAttribute("data-impressed", 'true');
      }
    };
  }

  const initialize = () => {
    var scrolling;
    if(/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent) !== false) {
      return;
    }
    window.onscroll = function () {
      if (!scrolling){
        scrolling = setTimeout(() => {
          validateImpressions();
          clearTimeout(scrolling);
          scrolling = undefined;
        }, 1000);        
      }
    }
  }

  initialize();
})();